<mat-chip-grid #codesChipGrid>
  <mat-chip-row
    *ngFor="let code of value"
    (removed)="removeCode(code)"
    [removable]="true"
  >
    {{ code }}
    <mat-icon matChipRemove>cancel</mat-icon>
  </mat-chip-row>

  <input
    [matChipInputFor]="codesChipGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [matChipInputAddOnBlur]="true"
    (matChipInputTokenEnd)="addCode($event)"
  />
</mat-chip-grid>
